import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './TermsOfService.css';

const TermsOfService = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('terms');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-of-service-container">
      <div className="terms-of-service-header">
        <div className="terms-of-service-header-content">
          <h1>{t('header.title')}</h1>
          <p className="terms-of-service-subtitle">
            {t('header.subtitle')}
          </p>
          <p className="terms-of-service-date">{t('header.lastUpdated')}</p>
        </div>
      </div>

      <div className="terms-of-service-content">
        <nav className="terms-of-service-nav">
          <h3>{t('navigation.title')}</h3>
          <ul>
            <li><a href="#acceptance">{t('navigation.acceptance')}</a></li>
            <li><a href="#description">{t('navigation.description')}</a></li>
            <li><a href="#user-accounts">{t('navigation.userAccounts')}</a></li>
            <li><a href="#user-conduct">{t('navigation.userConduct')}</a></li>
            <li><a href="#safety">{t('navigation.safety')}</a></li>
            <li><a href="#liability">{t('navigation.liability')}</a></li>
            <li><a href="#contact">{t('navigation.contact')}</a></li>
            <li><a href="#acknowledgment">{t('navigation.acknowledgment')}</a></li>
          </ul>
        </nav>

        <div className="terms-of-service-main">
          <section id="acceptance">
            <h2>{t('acceptance.title')}</h2>
            <p>{t('acceptance.description1')}</p>
            <p>{t('acceptance.description2')}</p>
            <ul>
              <li>{t('acceptance.conditions.read')}</li>
              <li>{t('acceptance.conditions.comply')}</li>
              <li>{t('acceptance.conditions.capacity')}</li>
              <li>{t('acceptance.conditions.privacy')}</li>
            </ul>
          </section>

          <section id="description">
            <h2>{t('description.title')}</h2>
            
            <h3>{t('description.overview.title')}</h3>
            <p>{t('description.overview.description')}</p>
            <ul>
              <li><strong>{t('description.overview.drivers')}</strong></li>
              <li><strong>{t('description.overview.packages')}</strong></li>
              <li><strong>{t('description.overview.community')}</strong></li>
            </ul>

            <h3>{t('description.limitations.title')}</h3>
            <p>{t('description.limitations.description')}</p>
            <ul>
              <li>{t('description.limitations.transportation')}</li>
              <li>{t('description.limitations.vehicles')}</li>
              <li>{t('description.limitations.employ')}</li>
              <li>{t('description.limitations.guarantee')}</li>
              <li>{t('description.limitations.carrier')}</li>
            </ul>
          </section>

          <section id="user-accounts">
            <h2>{t('userAccounts.title')}</h2>
            
            <h3>{t('userAccounts.eligibility.title')}</h3>
            <p>{t('userAccounts.eligibility.description')}</p>
            <ul>
              <li>{t('userAccounts.eligibility.age')}</li>
              <li>{t('userAccounts.eligibility.capacity')}</li>
              <li>{t('userAccounts.eligibility.prohibited')}</li>
              <li>{t('userAccounts.eligibility.banned')}</li>
              <li>{t('userAccounts.eligibility.truthful')}</li>
            </ul>

            <h3>{t('userAccounts.security.title')}</h3>
            <p>{t('userAccounts.security.description')}</p>
            <ul>
              <li>{t('userAccounts.security.confidentiality')}</li>
              <li>{t('userAccounts.security.activities')}</li>
              <li>{t('userAccounts.security.unauthorized')}</li>
              <li>{t('userAccounts.security.passwords')}</li>
              <li>{t('userAccounts.security.current')}</li>
            </ul>
          </section>

          <section id="user-conduct">
            <h2>{t('userConduct.title')}</h2>
            
            <h3>{t('userConduct.prohibited.title')}</h3>
            <p>{t('userConduct.prohibited.description')}</p>
            <ul>
              <li><strong>{t('userConduct.prohibited.falseInfo')}</strong></li>
              <li><strong>{t('userConduct.prohibited.harassment')}</strong></li>
              <li><strong>{t('userConduct.prohibited.violateLaws')}</strong></li>
              <li><strong>{t('userConduct.prohibited.circumventFees')}</strong></li>
              <li><strong>{t('userConduct.prohibited.spam')}</strong></li>
              <li><strong>{t('userConduct.prohibited.interfere')}</strong></li>
            </ul>
          </section>

          <section id="safety">
            <h2>{t('safety.title')}</h2>
            
            <h3>{t('safety.measures.title')}</h3>
            <p>{t('safety.measures.description')}</p>
            <ul>
              <li>{t('safety.measures.verification')}</li>
              <li>{t('safety.measures.ratings')}</li>
              <li>{t('safety.measures.messaging')}</li>
              <li>{t('safety.measures.reporting')}</li>
              <li>{t('safety.measures.trustScoring')}</li>
              <li>{t('safety.measures.guidelines')}</li>
            </ul>

            <h3>{t('safety.responsibilities.title')}</h3>
            <p>{t('safety.responsibilities.description')}</p>
            <ul>
              <li>{t('safety.responsibilities.meetSafe')}</li>
              <li>{t('safety.responsibilities.trustInstincts')}</li>
              <li>{t('safety.responsibilities.reportSuspicious')}</li>
              <li>{t('safety.responsibilities.maintainBoundaries')}</li>
              <li>{t('safety.responsibilities.followLaws')}</li>
              <li>{t('safety.responsibilities.notImpaired')}</li>
            </ul>
          </section>

          <section id="liability">
            <h2>{t('liability.title')}</h2>
            
            <h3>{t('liability.disclaimer.title')}</h3>
            <p>{t('liability.disclaimer.description')}</p>
            <ul>
              <li>{t('liability.disclaimer.availability')}</li>
              <li>{t('liability.disclaimer.compatibility')}</li>
              <li>{t('liability.disclaimer.accuracy')}</li>
              <li>{t('liability.disclaimer.safety')}</li>
              <li>{t('liability.disclaimer.disputes')}</li>
            </ul>

            <h3>{t('liability.interactions.title')}</h3>
            <p>{t('liability.interactions.description')}</p>
            <ul>
              <li>{t('liability.interactions.userDisputes')}</li>
              <li>{t('liability.interactions.actions')}</li>
              <li>{t('liability.interactions.damage')}</li>
              <li>{t('liability.interactions.packages')}</li>
              <li>{t('liability.interactions.payments')}</li>
            </ul>
          </section>

          <section id="contact">
            <h2>{t('contact.title')}</h2>
            
            <div className="contact-info-box">
              <p><strong>{t('contact.contactInfo.title')}</strong></p>
              <p>{t('contact.contactInfo.email')}</p>
              <p>{t('contact.contactInfo.support')}</p>
              <p>{t('contact.contactInfo.privacy')}</p>
              <p>{t('contact.contactInfo.safety')}</p>
              <p>{t('contact.contactInfo.address')}</p>
              <p>{t('contact.contactInfo.website')}</p>
            </div>

            <h3>{t('contact.responseTimes.title')}</h3>
            <p>{t('contact.responseTimes.description')}</p>
            <ul>
              <li><strong>{t('contact.responseTimes.general')}</strong></li>
              <li><strong>{t('contact.responseTimes.technical')}</strong></li>
              <li><strong>{t('contact.responseTimes.safety')}</strong></li>
              <li><strong>{t('contact.responseTimes.legal')}</strong></li>
            </ul>
          </section>

          <section id="acknowledgment">
            <h2>{t('acknowledgment.title')}</h2>
            <p>{t('acknowledgment.description')}</p>
            <ul>
              <li>{t('acknowledgment.conditions.read')}</li>
              <li>{t('acknowledgment.conditions.bound')}</li>
              <li>{t('acknowledgment.conditions.risks')}</li>
              <li>{t('acknowledgment.conditions.responsible')}</li>
              <li>{t('acknowledgment.conditions.accept')}</li>
              <li>{t('acknowledgment.conditions.platform')}</li>
              <li>{t('acknowledgment.conditions.safety')}</li>
            </ul>
            <div className="acknowledgment-box">
              <h4>{t('acknowledgment.reminder.title')}</h4>
              <p>{t('acknowledgment.reminder.description1')}</p>
              <p>{t('acknowledgment.reminder.description2')}</p>
            </div>
          </section>
        </div>
      </div>

      <div className="terms-of-service-footer">
        <button onClick={() => navigate(-1)} className="terms-back-button">
          {t('buttons.goBack')}
        </button>
        <button onClick={() => navigate('/')} className="terms-home-button">
          {t('buttons.homePage')}
        </button>
      </div>
    </div>
  );
};

export default TermsOfService;